<template>
  <header id="navbar-content">
    <div class="header-content">
      <!-- Logo and Brand Section -->
      <div class="brand-section">
        <img
          src="@/assets/logo-shanrise.png"
          alt="Shanrise Logo"
          class="brand-logo"
        />
        <span class="brand-name">Shanrise Bimbel</span>
      </div>

      <!-- Mobile Menu Button -->
      <button class="mobile-menu-btn" @click="toggleMobileMenu">
        <i :class="isMobileMenuOpen ? 'uil uil-times' : 'uil uil-bars'"></i>
      </button>

      <!-- Navigation Links -->
      <div :class="['nav-links', { 'show-mobile-menu': isMobileMenuOpen }]">
        <div class="nav-items">
          <router-link to="/" class="nav-icon" @click="closeMobileMenu">
            <i class="uil uil-file-alt font-size-15 me-1"></i>
            <span class="align-middle font-size-15">List Soal</span>
          </router-link>
          <router-link to="/scores" class="nav-icon" @click="closeMobileMenu">
            <i class="uil uil-chart-line font-size-15 me-1"></i>
            <span class="align-middle font-size-15">Nilai</span>
          </router-link>
        </div>

        <div class="user-menu">
          <div class="user-section" @click="toggleUserDropdown">
            <span class="user-name">
              HALO,
              <strong v-if="userData">{{ userData.nama || "User" }}</strong>
            </span>
            <i
              :class="[
                'uil-angle-down font-size-15',
                { rotate: isUserDropdownOpen },
              ]"
            ></i>
          </div>

          <!-- User Dropdown Menu -->
          <div
            v-show="isUserDropdownOpen"
            class="user-dropdown"
            :class="{ show: isUserDropdownOpen }"
          >
            <button @click="logoutUser" class="logout-btn">
              <i class="uil uil-signout me-1"></i>
              Logout
            </button>
          </div>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import { menuItems } from "./horizontal-menu";
import { layoutComputed, authFackMethods } from "@/state/helpers";
import axios from "axios";
import { authHeader } from "../helpers/fakebackend/auth-header";

export default {
  props: {
    type: {
      type: String,
      required: true,
    },
    width: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      isDevelopment: process.env.VUE_APP_DEFAULT_AUTH,
      menuItems: menuItems,
      dataMe: null,
      userData: null,
      isMobileMenuOpen: false,
      isUserDropdownOpen: false,
    };
  },
  computed: {
    ...layoutComputed,
  },
  mounted() {
    this.activateParentDropdown();
    this.$router.afterEach(() => {
      this.activateParentDropdown();
    });
    this.getMe();
  },
  methods: {
    ...authFackMethods,
    _removeAllClass(className) {
      const els = document.getElementsByClassName(className);
      while (els[0]) {
        els[0].classList.remove(className);
      }
    },
    toggleMobileMenu() {
      this.isMobileMenuOpen = !this.isMobileMenuOpen;
      if (this.isMobileMenuOpen) {
        this.closeUserDropdown();
      }
    },
    closeMobileMenu() {
      this.isMobileMenuOpen = false;
    },
    toggleUserDropdown(event) {
      event.stopPropagation();
      this.isUserDropdownOpen = !this.isUserDropdownOpen;
    },
    closeUserDropdown() {
      this.isUserDropdownOpen = false;
    },
    handleClickOutside(event) {
      const userMenu = document.querySelector(".user-menu");
      if (userMenu && !userMenu.contains(event.target)) {
        this.closeUserDropdown();
      }
    },
    activateParentDropdown() {
      // Existing dropdown activation logic
      const resetParent = (el) => {
        console.log(el);
        // ... (keep existing implementation)
      };
      var links = document.getElementsByClassName("side-nav-link-ref");
      var matchingMenuItem = null;
      for (let i = 0; i < links.length; i++) {
        resetParent(links[i]);
      }
      for (var i = 0; i < links.length; i++) {
        if (window.location.pathname === links[i].pathname) {
          matchingMenuItem = links[i];
          break;
        }
      }
      if (matchingMenuItem) {
        // ... (keep existing implementation)
      }
    },
    onMenuClick(event) {
      event.preventDefault();
      const nextEl = event.target.nextElementSibling;
      if (nextEl) {
        const parentEl = event.target.parentNode;
        if (parentEl) {
          parentEl.classList.remove("show");
        }
        nextEl.classList.toggle("show");
      }
      return false;
    },
    hasItems(item) {
      return item.subItems !== undefined ? item.subItems.length > 0 : false;
    },
    logoutUser() {
      localStorage.removeItem("userData");
      this.logout();
      this.$router.push({ path: "/account/login" });
    },
    async getMe() {
      try {
        const response = await axios.get(
          `${process.env.VUE_APP_API_BASE_URL}/api/me`,
          { headers: authHeader() }
        );
        const userData = response.data.data;
        // Store in localStorage
        localStorage.setItem("userData", JSON.stringify(userData));
        this.userData = userData;
        this.$store.dispatch("loginUser", userData.id);
      } catch (error) {
        console.error("Error fetching user data:", error);
      }
    },
  },
};
</script>

<style scoped>
header {
  position: sticky;
  top: 0;
  z-index: 100;
  background-color: #fff;
  box-shadow: rgba(0, 0, 0, 0.05) 0px 6px 24px 0px,
    rgba(0, 0, 0, 0.08) 0px 0px 0px 1px;
}

.header-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 75px;
  /* padding: 0 3rem; */
  max-width: 1400px;
  margin: 0 auto;
}

.brand-section {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.brand-logo {
  height: 4rem;
  padding: 10px;
}

.brand-name {
  color: #503668;
  font-size: 18px;
  font-weight: 700;
}

.nav-links {
  display: flex;
  align-items: center;
  gap: 2rem;
}

.nav-items {
  display: flex;
  gap: 1rem;
}

.nav-icon {
  text-decoration: none;
  color: inherit;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.user-section {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.mobile-menu-btn {
  display: none;
  background: none;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
  color: #503668;
}

/* Responsive Styles */
@media (max-width: 768px) {
  .header-content {
    padding: 0 0.5rem;
  }

  .mobile-menu-btn {
    display: block;
  }

  .nav-links {
    position: absolute;
    top: 75px;
    left: 0;
    right: 0;
    background-color: #fff;
    flex-direction: column;
    padding: 1rem;
    gap: 1rem;
    box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 6px -1px;
    display: none;
  }

  .show-mobile-menu {
    display: flex;
  }

  .nav-items {
    flex-direction: column;
    width: 100%;
    gap: 0.2rem;
  }

  .nav-icon {
    padding: 0.5rem 0;
  }

  .user-section {
    padding: 0.5rem 0;
    width: 100%;
  }
}

@media (max-width: 480px) {
  .brand-name {
    font-size: 16px;
  }

  .brand-logo {
    height: 3rem;
  }
}

.user-menu {
  position: relative;
}

.user-section {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  cursor: pointer;
  padding: 0.5rem;
  border-radius: 4px;
  transition: background-color 0.2s ease;
}

.user-section .uil-angle-down {
  transition: transform 0.2s ease;
}

.user-section .rotate {
  transform: rotate(180deg);
}

.user-dropdown {
  position: absolute;
  top: calc(100% + 0.5rem);
  right: 0;
  background-color: white;
  border-radius: 4px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  min-width: 150px;
  opacity: 0;
  transform: translateY(-10px);
  transition: all 0.2s ease;
  visibility: hidden;
}

.user-dropdown.show {
  opacity: 1;
  transform: translateY(0);
  visibility: visible;
}

.logout-btn {
  display: flex;
  align-items: center;
  width: 100%;
  padding: 0.75rem 1rem;
  border: none;
  background: none;
  color: #503668;
  cursor: pointer;
  transition: background-color 0.2s ease;
  font-size: 0.9rem;
}

/* Update Mobile Styles */
@media (max-width: 768px) {
  .nav-links {
    transition: opacity 0.3s ease, transform 0.3s ease;
    opacity: 0;
    transform: translateY(-10px);
    pointer-events: none;
  }

  .show-mobile-menu {
    opacity: 1;
    transform: translateY(0);
    pointer-events: auto;
  }

  .user-dropdown {
    position: static;
    box-shadow: none;
    border-top: 1px solid #eee;
    margin-top: 0.5rem;
  }
}
</style>
